module.exports = __webpack_public_path__ + "img/location_master.5faa5669.svg";